package com.rainbowclubs.rainbow.data.requests

import kotlinx.serialization.Serializable

@Serializable
data class UpdateEventRequest(
    val startsAt: Long,
    val endsAt: Long,
    val description: String,
    val title: String,
    val location: String? = null,
)
